<div class="carousel-overlay">
  <div class="carousel-dialog">
    <button class="close-btn" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="carousel-image-container">
      <img alt="Hint Image" [src]="data.images[currentIndex]" />
    </div>
    <div class="carousel-controls">
      <button mat-icon-button (click)="prev()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="carousel-index">{{ currentIndex + 1 }} / {{ data.images.length }}</span>
      <button mat-icon-button (click)="next()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
